"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMuiDialogActionsOverrides = void 0;
var createMuiDialogActionsOverrides = function (_a) {
    var spacing = _a.spacing;
    return ({
        root: {
            padding: spacing(4, 12, 12),
            flexWrap: "wrap",
        },
        spacing: {
            "& > :not(:first-child)": {
                marginLeft: spacing(4),
                "&[class*='MuiButton-fullWidth']": {
                    marginLeft: 0,
                    marginTop: spacing(4),
                },
            },
        },
    });
};
exports.createMuiDialogActionsOverrides = createMuiDialogActionsOverrides;
//# sourceMappingURL=MuiDialogActions.js.map